<div class="page-title">Get started</div>
<div class="subtitle">
  Connect with colleague and set up workspaces to grow your network
</div>
<div class="cards">
  @for (card of cards; track card; let index = $index) {
    <div class="cta-card">
      <div
        matRipple
        [matRippleColor]="'rgba(10,10,10,0.03)'"
        class="cta-card-button celo-cursor-pointer"
        (click)="cardClick(card.id, card)"
      >
        <img [src]="card.image" alt="" />
        <div class="title">{{ card.title }}</div>
        <div class="description">{{ card.description }}</div>
      </div>
    </div>
  }
</div>
